// eslint-disable-next-line import/prefer-default-export
export const LIGHT_BOX_SELECTOR = {
  modalContainerId: 'photo-bp_container',
  lightBoxImgId: 'photo-light-box__img',
  nextBottomId: 'photo-light-box__arrow_right',
  prevBottomId: 'photo-light-box__arrow_left',
  navBotContPrevId: 'photo-light-box__arrow_left_container',
  navBotContNextId: 'photo-light-box__arrow_right_container',
  svgBottomPrevId: 'photo-light-box__arrow_left_svg',
  svgBottomNextId: 'photo-light-box__arrow_right_svg',
};
